// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__PG5O1","head":"ProcedureTableInfo_head__1P51O"};